// extracted by mini-css-extract-plugin
module.exports = {"mainFlexColumn":"Layout_mainFlexColumn__3Nf9C","mainStaffList":"Layout_mainStaffList__2cGNS"};